export const getContactTopicsListPayload = (contactid) => {
  var payload;
  payload = {
    properties: [
      "ctpt_contact_ctpt_topicid",
      "ctpt_topicsid",
      "contactid"
    ],
    formattedFields: [],
    filter: {
      globalfilter: "",
      globalAndOperator: false,
      fieldAndOperator: true,
      filterfields: [
        {
          field: "contactid",
          searchvalue: contactid,
          type: "guid"
        }
      ],
    },
    recordtype: "ctpt_contact_ctpt_topicset",
    idfield: "ctpt_contact_ctpt_topicid",
    continuationToken: "",
    pazesize: "10",
  };
  return payload;
}

export const GetTopicsListPayload = {
  properties: ["ctpt_topicsid", "ctpt_topic", "ctpt_description", "ctpt_categories"],
  recordtype: "ctpt_topics",
  formattedFields: ["_ctpt_categories_value"],
  filter: {
    globalfilter: "",
    globalAndOperator: false,
    fieldAndOperator: false,
    filterfields: [],
  },
  Aggregate: {
    AggregateFields: [],
  },
  sortfield: {
    field: "ctpt_topic",
    sorttype: "asc",
  },
  idfield: "ctpt_topicsid",
  continuationToken: "",
  pazesize: "10",
};

export const AddTopicPayload = (jsonData) => {
  const details = jsonData.data
  console.log('AddTopicPayload',details);
  var payload;
  payload = {
    "recordtype": "contacts",
    "data": [
      {
        "name": "ctpt_Contact_ctpt_Topics_ctpt_Topics",
        "manyToManyValues": [
          {
            "parentId": jsonData.contactid,
            "parentEntityName": "contacts",
            "childId": details[0].value,
            "childEntityName": "ctpt_topicses",
            "type": "add"
          }
        ],
        "relatedentity": "ctpt_Contact_ctpt_Topics_ctpt_Topics",
        "getRelatedEntity": "ctpt_contact_ctpt_topicsset",
        "type": "manytomany"
      }
    ]
  }
  return payload;
}

export const DeleteTopicPayload = (contactId, topicId) => {
  var payload;
  payload = {
    "recordtype": "contacts",
    "id": contactId,
    "data": [
      {
        "name": "ctpt_Contact_ctpt_Topics_ctpt_Topics",
        "manyToManyValues": [
          {
            "parentId": contactId,
            "parentEntityName": "contacts",
            "childId": topicId,
            "childEntityName": "ctpt_topicses",
            "type": "delete"
          }
        ],
        "relatedentity": "ctpt_Contact_ctpt_Topics_ctpt_Topics",
        "getRelatedEntity": "ctpt_contact_ctpt_topicsset",
        "type": "manytomany"
      }
    ]
  }
  return payload;
}

